import React, { useCallback, useEffect } from 'react'

import { Box } from '@mui/material'
import { ArrowRight } from 'lucide-react'

import PageBanner from '../../shared/components/PageBanner/PageBanner.component'
import StepByStepGuide from '../../shared/components/StepByStepGuide/StepByStepGuide.component'
import TestimonialCarousel from '../../shared/components/TestimonialCarousel/TestimonialCarousel.component'

import { PageBannerImage } from '../../redux/states/firebaseRemoteConfig/firebaseRemoteConfig.types'
import { RootState } from '../../redux/store/store.types'
import router from '../../router/functions/router.functions'
import routes from '../../router/routes.dictionary'
import { UserRole } from '../../shared/functions/UserRole/userRoleManagement.types'
import { setUserRole } from '../../shared/functions/UserRole/userRoleManagment.functions'
import { useAppSelector } from '../../shared/hooks/redux.hooks'
import { howItWorksSection, sendPageDictionary } from './Send.dictionary'
import styles from './Send.styles'

const Send: React.FC = () => {
  const { values } = useAppSelector((state: RootState) => state.firebaseRemoteConfig)
  const sendBannerImages = (values?.sendBannerImages as PageBannerImage[]) ?? []

  const navigate = router.navigate()

  useEffect(() => {
    setUserRole(UserRole.sender)
  }, [])

  const handleStartShipping = useCallback(() => {
    navigate(routes.createFulfillmentOrder.path)
  }, [navigate])

  return (
    <Box sx={styles.container}>
      <Box sx={styles.bannerContainer}>
        <PageBanner
          images={sendBannerImages}
          title={sendPageDictionary.heroTitle}
          subtitle={sendPageDictionary.heroSubtitle}
          primaryAction={{
            text: sendPageDictionary.startShippingButton,
            onClick: handleStartShipping,
            endIcon: <ArrowRight size={18} color="#FFFFFF" />
          }}
        />
      </Box>

      <Box id="how-it-works">
        <StepByStepGuide
          steps={howItWorksSection.steps}
          title={howItWorksSection.title}
          subtitle={howItWorksSection.subtitle}
        />
      </Box>

      <TestimonialCarousel />
    </Box>
  )
}

export default Send
